import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetTotalTicket } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl5 + 'total-tickets';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get("total-tickets")
        var x = []
        for (var i = 0; i < data.size; i++) {
            var datinti = data.get(i)
            var obj = { name: datinti.get("tanggal")}
            obj["TotalTickets"] = parseInt(datinti.get("total-tickets"))
            x.push(obj)

        }
        data=x 
    }
    dispatch({ type: GetTotalTicket, data:fromJS(data)});
    return data
};